// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qsnTm","skeleton-animation":"styles_skeleton-animation__GOW2u"};